import { BackgroundStylesInterface } from 'common/types/background-interfaces'

export const backgroundVariants = {
  Default: 'Default',
  Fixed: 'Fixed',
  Repeat: 'Repeat',
  Width100: 'Width100',
  Width100Height100: 'Width100Height100',
  ScalesWithoutCropping: 'ScalesWithoutCropping',
} as const

export type BackgroundVariantsType =
  (typeof backgroundVariants)[keyof typeof backgroundVariants]

export const backgroundPositions = {
  TopLeft: 'TopLeft',
  TopCenter: 'TopCenter',
  TopRight: 'TopRight',
  CenterLeft: 'CenterLeft',
  CenterCenter: 'CenterCenter',
  CenterRight: 'CenterRight',
  BottomLeft: 'BottomLeft',
  BottomCenter: 'BottomCenter',
  BottomRight: 'BottomRight',
} as const

export type BackgroundPositionType =
  (typeof backgroundPositions)[keyof typeof backgroundPositions]

export const backGroundPositionLocoKeys = {
  [backgroundVariants.Default]:
    'components.core.settings.background_position.default.title',
  [backgroundVariants.Fixed]:
    'components.core.settings.background_position.fixed.title',
  [backgroundVariants.Repeat]:
    'components.core.settings.background_position.repeat.title',
  [backgroundVariants.Width100]:
    'components.core.settings.background_position.fill_100%_width.title',
  [backgroundVariants.Width100Height100]:
    'components.core.settings.background_position.fill_100%_width_height.title',
  [backgroundVariants.ScalesWithoutCropping]:
    'components.core.settings.background_position.scales_without_cropping.title',
}

export type backGroundPositionLocoKeysType =
  (typeof backGroundPositionLocoKeys)[keyof typeof backGroundPositionLocoKeys]

export const backgroundPositionStyles: Record<
  BackgroundVariantsType,
  BackgroundStylesInterface
> = {
  [backgroundVariants.Default]: {
    backgroundSize: 'initial',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'initial',
  },
  [backgroundVariants.Fixed]: {
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
  },
  [backgroundVariants.Repeat]: {
    backgroundSize: 'initial',
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'repeat',
    backgroundAttachment: 'initial',
  },
  [backgroundVariants.Width100]: {
    backgroundSize: '100%',
    backgroundPosition: '50% 0%',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'initial',
  },
  [backgroundVariants.Width100Height100]: {
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'initial',
  },
  [backgroundVariants.ScalesWithoutCropping]: {
    backgroundSize: 'contain',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'initial',
  },
}

export const backgroundPositionValues: Record<BackgroundPositionType, string> =
  {
    [backgroundPositions.TopLeft]: '0% 0%',
    [backgroundPositions.TopCenter]: '50% 0%',
    [backgroundPositions.TopRight]: '100% 0%',
    [backgroundPositions.CenterLeft]: '0% 50%',
    [backgroundPositions.CenterCenter]: '50% 50%',
    [backgroundPositions.CenterRight]: '100% 50%',
    [backgroundPositions.BottomLeft]: '0% 100%',
    [backgroundPositions.BottomCenter]: '50% 100%',
    [backgroundPositions.BottomRight]: '100% 100%',
  }
